import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { IPartnerRecord } from 'clickNgo/entities/partner/models'

import { RequestStatus } from '../../configs/service'

import { initPartnerDashboardAction } from './actions/initPartnerDashboardAction'
import { initialState, MAX_HISTORY_PARTNER_LIST_SIZE } from './configs'
import {
  initPartnerDashboardFulfilled,
  initPartnerDashboardPending,
  initPartnerDashboardRejected,
} from './reducers/initPartnerDashboardReducer'

export const partnerDashboardSlice = createSlice({
  name: 'partnerDashboard',
  initialState: initialState,
  reducers: {
    setFavoritePartnerList: (state, action: PayloadAction<IPartnerRecord[]>) => {
      state.favoritePartnerList.data = action.payload
    },
    setUserHistoryList: (state, action: PayloadAction<IPartnerRecord[]>) => {
      const newHistoryPartnerList = action.payload

      if (newHistoryPartnerList.length <= MAX_HISTORY_PARTNER_LIST_SIZE) {
        state.userHistoryList.data = newHistoryPartnerList
      } else {
        newHistoryPartnerList.pop()
        state.userHistoryList.data = newHistoryPartnerList
      }
    },
    setUserPartnerList: (state, action: PayloadAction<IPartnerRecord[]>) => {
      state.userPartnerList.data = action.payload
    },
    setSelectedPartnerRecord: (state, action: PayloadAction<IPartnerRecord>) => {
      const selectedPartnerRecord = action.payload
      state.selectedPartnerRecord.data = selectedPartnerRecord
    },
    resetSelectedPartner: (state) => {
      state.selectedPartnerRecord = {
        data: null,
        status: RequestStatus.FULFILLED,
        message: '',
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(initPartnerDashboardAction.pending, initPartnerDashboardPending)
      .addCase(initPartnerDashboardAction.rejected, initPartnerDashboardRejected)
      .addCase(initPartnerDashboardAction.fulfilled, initPartnerDashboardFulfilled)
  },
})

export const {
  resetSelectedPartner,
  setFavoritePartnerList,
  setUserHistoryList,
  setSelectedPartnerRecord,
} = partnerDashboardSlice.actions

export const partnerDashboardReduce = partnerDashboardSlice.reducer

import('./listeners')
